type UserLike = {
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    id?: string;
};

/**
 * Stable display name for list titles, breadcrumbs, and headers.
 * Avoids the literal "undefined" when optional name fields are missing.
 */
export function formatUserDisplayName(
    record: UserLike | null | undefined
): string {
    if (!record) {
        return 'User';
    }
    const parts = [record.first_name, record.last_name].filter(
        (v): v is string => v != null && String(v).trim() !== ''
    );
    if (parts.length > 0) {
        return parts.join(' ');
    }
    const email = record.email?.trim();
    if (email) {
        return email;
    }
    return record.id ?? 'User';
}
